import { render, staticRenderFns } from "./comp_BookEditor.vue?vue&type=template&id=df6b8dc4&scoped=true&"
import script from "./comp_BookEditor.vue?vue&type=script&lang=js&"
export * from "./comp_BookEditor.vue?vue&type=script&lang=js&"
import style0 from "./comp_BookEditor.vue?vue&type=style&index=0&id=df6b8dc4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df6b8dc4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDialog,VIcon})
